import { Draggable } from '@hello-pangea/dnd';
import { ReactElement } from 'react';
import { IGRowModel, TableCell } from './GCell';
import { IGColumnProps } from './IGColumnProps';

interface IGRowProps<T extends IGRowModel> {
  item: T;
  isDragging: boolean;
  index: number;
  enableDrag?: boolean;
  columns: IGColumnProps<T>[];
  onClick: () => void;
}

export const GRow = <T extends IGRowModel>(props: IGRowProps<T>): ReactElement => {
  const { item, isDragging, index, enableDrag, columns, onClick } = props;

  return (
    <Draggable
      key={`table-key-${item.id}`}
      draggableId={`table-key-${item.id}`}
      index={index}
      isDragDisabled={!enableDrag}
    >
      {(provided): ReactElement => (
        <tr
          className='g-row'
          {...provided.draggableProps}
          ref={provided.innerRef}
          onClick={onClick}
        >
          {columns.map((column: IGColumnProps<T>, columnIndex: number) => (
            <TableCell
              key={columnIndex}
              column={column}
              index={columnIndex}
              item={item}
              provided={provided}
              isDragOccurring={isDragging}
            />
          ))}
        </tr>
      )}
    </Draggable>
  );
};
